import { ServiceCategoryService } from "../../../services/serviceCategory/serviceCategory.service";
import { useQuery } from "react-query";
export var useAllServiceCategories = function () {
    var _a;
    var query = useQuery('allServiceCategories', function () {
        return ServiceCategoryService.getAllServiceCategories({
            limit: {
                offset: 0,
                limit: 1000,
                sort: [{ field: "name", direction: "ASC" }]
            }
        });
    });
    return ((_a = query.data) === null || _a === void 0 ? void 0 : _a.content) || [];
};
export var useServiceCategories = function (categoryIds) {
    var _a;
    var idsSorted = categoryIds.sort(function (a, b) { return a.localeCompare(b); });
    var query = useQuery(['allServiceCategories', idsSorted], function () {
        return ServiceCategoryService.getAllServiceCategories({
            id: idsSorted,
            limit: {
                offset: 0,
                limit: 1000,
                sort: [{ field: "name", direction: "ASC" }]
            }
        });
    });
    return ((_a = query.data) === null || _a === void 0 ? void 0 : _a.content) || [];
};
